import MonthRangeParent from './month-range-picker';


export const MonthRangePicker=MonthRangeParent;